import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=f5c63c12"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.vue?vue&type=style&index=0&id=f5c63c12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.aspect_rules_js/vue-loader@15.11.1_1687856227/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports